import { forwardRef } from 'react';

import type { TextFieldModel } from '../../../types';
import IconButton from '../../Button/Icon';
import Icon from '../../Icon';
import BaseStyleTextField from '../BaseStyleTextField';

import s from './CalendarTextField.module.scss';

export interface CalendarTextFieldProps extends TextFieldModel {
  onClick: () => void;
}

const CalendarTextField = forwardRef<HTMLInputElement, CalendarTextFieldProps>(({ onClick, success, ...props }, ref) => {
  return (
    <BaseStyleTextField {...props} ref={ref}>
      {success && <Icon className={s.icon} type="check-mark" size={24} color="green.600" />}
      <IconButton icon="calendar" color="gray.500" onClick={onClick} />
    </BaseStyleTextField>
  );
});

export default CalendarTextField;
